import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {Daytime, QuestionTime} from '../model/model';
import {DaytimeRepository} from '../repositories/daytime.repository';

@Injectable()
export class DaytimeService {

    constructor(public daytimeRepository: DaytimeRepository) { }

    public getDaytime(): Observable<Daytime> {
        return this.daytimeRepository.getDaytime();
    }

    public getQuestionTimeByLastAnswerDate(lastAnswerDate: Date): Observable<QuestionTime> {
      return this.daytimeRepository.getQuestionTimeByLastAnswerDate(lastAnswerDate);
    }

    public getNextQuestionTime(lastQuestionTime: QuestionTime): Observable<QuestionTime> {
      return this.daytimeRepository.getNextQuestionTime(lastQuestionTime);
    }

    public getCurrentQuestionTime(): Observable<QuestionTime> {
      return this.daytimeRepository.getCurrentQuestionTime();
    }

}
